import {Loader} from '@googlemaps/js-api-loader';
import {MarkerClusterer} from "@googlemaps/markerclusterer";
import {checkIfInScreen} from '../helpers/lazy-load';


const loader = new Loader({
    apiKey: "AIzaSyC6pvAGRjanBW4z1TAsRdotSOztRrMII2I",
});

let $map = $("#map-markets")
let lat = $map.data('center-lat')
if (!lat) lat = 56
let lng = $map.data('center-lng')
if (!lng) lng = 23
let zoom = $map.data('zoom')
if (!zoom) zoom = 6

const mapOptions = {
    center: {
        lat: lat,
        lng: lng
    },
    zoom: zoom,
    zoomControl: true,
    mapTypeControl: false,
    scaleControl: true,
    streetViewControl: false,
    rotateControl: true,
    fullscreenControl: false,
    styles: [{"featureType":"water","elementType":"geometry","stylers":[{"color":"#e9e9e9"},{"lightness":17}]},{"featureType":"landscape","elementType":"geometry","stylers":[{"color":"#f5f5f5"},{"lightness":20}]},{"featureType":"road.highway","elementType":"geometry.fill","stylers":[{"color":"#ffffff"},{"lightness":17}]},{"featureType":"road.highway","elementType":"geometry.stroke","stylers":[{"color":"#ffffff"},{"lightness":29},{"weight":0.2}]},{"featureType":"road.arterial","elementType":"geometry","stylers":[{"color":"#ffffff"},{"lightness":18}]},{"featureType":"road.local","elementType":"geometry","stylers":[{"color":"#ffffff"},{"lightness":16}]},{"featureType":"poi","elementType":"geometry","stylers":[{"color":"#f5f5f5"},{"lightness":21}]},{"featureType":"poi.park","elementType":"geometry","stylers":[{"color":"#dedede"},{"lightness":21}]},{"elementType":"labels.text.stroke","stylers":[{"visibility":"on"},{"color":"#ffffff"},{"lightness":16}]},{"elementType":"labels.text.fill","stylers":[{"saturation":36},{"color":"#333333"},{"lightness":40}]},{"elementType":"labels.icon","stylers":[{"visibility":"off"}]},{"featureType":"transit","elementType":"geometry","stylers":[{"color":"#f2f2f2"},{"lightness":19}]},{"featureType":"administrative","elementType":"geometry.fill","stylers":[{"color":"#fefefe"},{"lightness":20}]},{"featureType":"administrative","elementType":"geometry.stroke","stylers":[{"color":"#fefefe"},{"lightness":17},{"weight":1.2}]}]
};

const mapInView = () => {

    let $map = $("#map-markets")
    let $markets = $('.js-markets');
    let $icons = $('.js-market-icons');

    if (!$map.length || !$markets.length) {
        $(window).unbind("scroll", mapInView);
        return false
    }


    if (checkIfInScreen($map[0])) {
        loader
            .load()
            .then((google) => {
                let map = new google.maps.Map($map[0], mapOptions);
                setupMarkers(map, $.parseJSON($markets.val()), $.parseJSON($icons.val()), google)
            })
            .catch(e => {
                // do something
            });

        $(window).unbind("scroll", mapInView);
    }
};

$(window).on('load', function () {
    $(window).bind("scroll", mapInView);
});



const setupMarkers = (map, markers, icons, google) => {

    if (!map && !markers && !google) {
        return false;
    }

    // Separate markers by term
    let markerGroup = groupBy(markers, 'term')

    // Go through each marker group
    for (const key in markerGroup) {

        let locations = markerGroup[key]
        let icon = icons[key]['markerIcon']
        let clusterIcon = icons[key]['clusterIcon']
        let term = key

        // Setup marker with a custom icon
        $.get(icon, function (svg) {

            // Create markers for each location in the markerGroup
            const markers = locations.map((location) => {
                let position = location.position
                const marker = new google.maps.Marker({
                    position,
                    icon,
                });


                // $(`[data-term='${term}']`).click(function() {
                //     map.panTo(marker.getPosition());
                // });

                // Change clusterIcon to hover
                google.maps.event.addListener(marker, "mouseover", function () {
                    marker.setIcon(getIcon(true, svg))
                });

                // Change clusterIcon to regular
                google.maps.event.addListener(marker, "mouseout", function () {
                    marker.setIcon(getIcon(false, svg))
                });

                // Change clusterIcon to regular
                google.maps.event.addListener(marker, "click", function () {
                    let accordionItem = $(".js-open-cluster[data-term='" + term +"']").find('.js-toggle-next')
                    toggleDropdown(accordionItem)
                });

                return marker;
            });

            // Setup marker cluster with a custom icon
            $.get(clusterIcon, function (svg) {

                // Get svg based on hover status -- map starts without hover
                let icon = getIcon(false, svg)

                // Render allows us to customize the visual behaviour of markerCluster
                const renderer = {
                    render({count, position}) {

                        // Setting up markerCluster marker
                        let marker = new google.maps.Marker({
                            label: {text: String(count), color: "white", fontSize: "14px"},
                            position,
                            icon,
                        })


                        // Change clusterIcon to hover
                        google.maps.event.addListener(marker, "mouseover", function () {
                            marker.setIcon(getIcon(true, svg))
                        });

                        // Change clusterIcon to regular
                        google.maps.event.addListener(marker, "mouseout", function () {
                            marker.setIcon(getIcon(false, svg))
                        });

                        // Change clusterIcon to regular
                        google.maps.event.addListener(marker, "click", function () {
                            let accordionItem = $(".js-open-cluster[data-term='" + term +"']").find('.js-toggle-next')
                            toggleDropdown(accordionItem)
                        });

                        // Return marker
                        return marker
                    }
                }

                // Create the marker cluster
                let markerCluster = new MarkerClusterer({map, markers, renderer});


                // Apply on click events
                // google.maps.event.addListener(markerCluster, 'clusterclick', function(cluster) {
                //     $("ul").find(`[data-slide='${current}']`)
                //     your code here
                // });

            }, 'text');

        }, 'text');
    }
}

// Returns correct svg style
const getIcon = (hover, svg) => {
    return {
        url: 'data:image/svg+xml;charset=utf-8,' + encodeURIComponent(animateSvgPath(hover, svg)),
        labelOrigin: new google.maps.Point(29, 49)
    }
}

// Adds animation styling to our custom svg
const animateSvgPath = (hover, svg) => {
    // Random id is needed, otherwise the browser remembers the status of the animation and it won't be animated again during hover.
    let randomID = Math.floor(Math.random()*(999-100+1)+100);

    if (hover) {

        // Add class to all paths
        let newSvg = svg.replace('<path ', '<path class="svg-mouse-over-' + randomID + '" ');

        // Add styling at the end of our svg
        return newSvg.replace('</svg>', `
            <style>
                .svg-mouse-over-${randomID} {animation: svgMouseOver 0.3s ease-in; animation-iteration-count: 1; animation-fill-mode: forwards; }
                
                @keyframes svgMouseOver {
                    0% {fill:#F7931E}
                    100% {fill:#030303}
                }
            </style>
            </svg>
    `)
    } else {
        // Add class to all paths
        let newSvg = svg.replace('<path ', '<path class="svg-mouse-leave-' + randomID + '" ');

        // Add styling at the end of our svg
        return newSvg.replace('</svg>', `
            <style>
                .svg-mouse-leave-${randomID} {animation: svgMouseOver 0.3s ease-in; animation-iteration-count: 1; animation-fill-mode: forwards; }
                
                @keyframes svgMouseOver {
                    0% {fill:#030303}
                    100% {fill:#F7931E}
                }
            </style>
            </svg>
        `)
    }


}


// Groups elements by property
const groupBy = (arr, property) => {
    return arr.reduce(function (memo, x) {
        if (!memo[x[property]]) {
            memo[x[property]] = [];
        }
        memo[x[property]].push(x);
        return memo;
    }, {});
}


$(document).on('click', '.js-toggle-next', function (e) {
    toggleDropdown($(this))
});

const toggleDropdown = ($this) => {
    console.log($this)
    $this.parent().siblings().removeClass('active').find('.js-dropdown').slideUp(300)
    $this.parent().toggleClass('active')
    $this.next('.js-dropdown').slideToggle(300)
}


